module.exports = {
    webrtcServer: "wss://gateway.norvoz.es:8989", 
  }
  